import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    component: Home
  },
  {
    path: '/about',
    name: '走进兴致力',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/service',
    name: '兴致力服务',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/service.vue'),
    children: [{
      path: "detail",
      name: " ",
      component: () => import(/* webpackChunkName: "about" */ '../views/detail.vue'),
    }]
  },
  {
    path: '/case',
    name: '成功案例',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/case.vue'),
    children: [
      {
        path: "detail",
        name: " ",
        component: () => import(/* webpackChunkName: "about" */ '../views/detail.vue'),
      }
    ]
  },
  {
    path: '/news',
    name: '媒体资讯',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/news.vue'),
    children: [

    ]
  },
  {
    path: '/contact',
    name: '联系我们',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/contact.vue')
  },
  {
    path: "/detail",
    name: " ",
    component: () => import(/* webpackChunkName: "about" */ '../views/detail.vue'),
  },
  {
    path: "/case-list",
    name: " ",
    component: () => import(/* webpackChunkName: "about" */ '../views/case-list.vue'),
    meta: {
      noNav: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((t, f, n) => {
  window.scrollTo(0, 0)
  n()
})
export default router
